import * as Constants from "../actions/constants";

const initialState = {
  apiError: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.API_ERROR:
      return {
        ...state,
        apiError: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
